import { render, staticRenderFns } from "./form-header-preview.vue?vue&type=template&id=44e3eaa1&scoped=true&"
import script from "./form-header-preview.vue?vue&type=script&lang=js&"
export * from "./form-header-preview.vue?vue&type=script&lang=js&"
import style0 from "./form-header-preview.vue?vue&type=style&index=0&id=44e3eaa1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e3eaa1",
  null
  
)

component.options.__file = "form-header-preview.vue"
export default component.exports